/// <summary>
/// dashboard visual for a simple signal 
/// Author: AFU<br />
/// Date: 13.8.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 -  13.8.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.DashboardPie", jQuery.common.vcBaseV4, {


    _create: function () {
        this._createVisual(417);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            // Locate the root container element by its CSS class.
            me._setRoot(".vc-dashboard-item-data");
            me.myRoot.css("height", "100%");
           
            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
   
    _initEvents: function () {
        var me = this;
        try {
            // Fetch signals first, then initialize the dashboard with the loaded data.
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        var me = this;
        try {
            me.myHtml = {};
            me.myHtml.wrapper = me._setObj("", "dashboard-pie").css({ "width": "100%", "height": "100%", "overflow": "hidden" });
            me.myHtml.chart = $("<div>").addClass("dashboard-pie-chart").css({ "width": "100%", "height": "100%" });
            me.myHtml.wrapper.append(me.myHtml.chart);
            me.myRoot.html(me.myHtml.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
 

    _fetch: function () {
        var me = this;
        try {
            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1, SumValues:true }, function (result) {
                if (result === null) { me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false); return false; }
                me._loadChart(result);
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _loadChart: function (result) {
        var me = this;
        try {

            var seriesList = [];
            seriesList.push({
                type: 'pie',
                name: '',
                size: '65%',
                data: [],
                showInLegend: true,
                dataLabels: { enabled: true, useHTML: true, format: '{point.percentage:.1f} %' }
            });
           
           
            $.each(result.Entries, function (i, s) {
                seriesList[0].data.push({ name: s.Name + ' [' + s.Unit + ']', y: (s.Status >-1 ? s.Value : 0) });
            });
           

            var options = {
                chart: { type: 'pie'},
                title: { text: null },
                legend: { useHTML: true, labelFormatter: function () { var text = $('<div>').html(this.name).text(); return '<span title="' + text.replace(/"/g, '&quot;') + '">' + this.name + '</span>'; } },
                tooltip: {
                    useHTML: true,
                    backgroundColor: '#ffffff',
                    borderColor: '#cccccc',
                    borderWidth: 1,
                    style: { opacity: '1' },
                    formatter: function () {
                        return this.key + '<br/><b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b> (' + Highcharts.numberFormat(this.percentage, 1, ',', '.') + ' %)';
                    }
                },
                series: seriesList
            };

            var ro = new RampOptions();
            var availableHeight = me.element.closest(".dashboard-charts-wrapper").height() || me.element.closest(".grid-stack-item-content").height() || me.myRoot.parent().height() || 300;
            me.myRoot.height(availableHeight);
            me.myHtml.chart.height(availableHeight);
            me.myHtml.chart.highcharts($.extend({}, ro.getTheme(), options));

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    /**
     * Handles error display states for the widget.
     * When an error occurs (bError=true), both the menu bar and content area are hidden,
     * leaving only the framework's error message visible to the user.
     * This ensures a clean UI when the widget cannot function due to missing data or server errors.
     *
     * Called by the framework's built-in error handling mechanism (inherited from vcBaseV4).
     *
     * @param {boolean} bError - true if an error state should be shown, false otherwise.
     * @returns {boolean} true on success, false on error.
     */
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                // Hide both menu and content to show only the error message.
                me.myHtml.wrapper.hide();
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});